import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { BaseSiteInitializer, CurrencyInitializer, LanguageInitializer } from '@spartacus/core';
import { SitePrefixInitializer } from '../services/site-prefix-initializer';

export function initializeCurrency(currencyInitializer: CurrencyInitializer) {
  const result = () => {
    currencyInitializer.initialize();
  };
  return result;
}

export function initializeLanguage(languageInitializer: LanguageInitializer) {
  const result = () => {
    languageInitializer.initialize();
  };
  return result;
}

export function initializeSitePrefix(sitePrefixInitializer: SitePrefixInitializer) {
  const result = () => {
    sitePrefixInitializer.initialize();
  };
  return result;
}

export function initializeBaseSite(baseSiteInitializer: BaseSiteInitializer) {
  const result = () => {
    baseSiteInitializer.initialize();
  };
  return result;
}

export const contextInitializerProviders: EnvironmentProviders = makeEnvironmentProviders([
  provideAppInitializer(() => {
    const initializerFn = initializeLanguage(inject(LanguageInitializer));
    return initializerFn();
  }),
  provideAppInitializer(() => {
    const initializerFn = initializeCurrency(inject(CurrencyInitializer));
    return initializerFn();
  }),
  provideAppInitializer(() => {
    const initializerFn = initializeSitePrefix(inject(SitePrefixInitializer));
    return initializerFn();
  }),
  provideAppInitializer(() => {
    const initializerFn = initializeBaseSite(inject(BaseSiteInitializer));
    return initializerFn();
  }),
]);
